import { Component, OnInit } from '@angular/core';
import { AdministrationService } from '../administration.service';
import D3Wrapper from '../d3-wrapper';

@Component({
  selector: 'feedbacks',
  templateUrl: './feedbacks.component.html',
  styleUrls: ['./feedbacks.component.scss']
})
export class FeedbacksComponent implements OnInit {
  public readonly LABELS: string[] = ["Strongly agree", "Agree", "Neutral", "Disagree", "Strongly disagree"];

  // feedback analysis chart
  // eslint-disable-next-line @typescript-eslint/naming-convention
  private static readonly DEFAULT_PERIOD: string = "month";
  public feedbackAnalysisFrequencyPeriod: string = FeedbacksComponent.DEFAULT_PERIOD;
  public isFeedbackAnalysisChartLoading: boolean = true;
  public isFeedbackAnalysisChartFailed: boolean = false;

  constructor(
    public adminService: AdministrationService,
  ) { }

  ngOnInit() {
    this.adminService.updateAuthentication().then((authenticated: boolean) => {
      if(authenticated){
        this.updateFeedbackAnalysisChart();
        this.adminService.getFeedback();
      }
    });
  }

  private updateFeedbackAnalysisChart(): void {
    this.isFeedbackAnalysisChartLoading = true;
    this.isFeedbackAnalysisChartFailed = false;
    this.adminService.getFeedbackAnalysis(this.feedbackAnalysisFrequencyPeriod).then((response: any) => {
      // create data for d3 stacked bar chart
      const wasHelpfulSubgroups = ["Strongly agree", "Agree", "Neutral", "Disagree", "Strongly disagree"];
      const wasHelpfulChartDataResponse = [{
        label: "wasHelpful",
        [wasHelpfulSubgroups[0]]: response["wasHelpful"]["1"] || 0,
        [wasHelpfulSubgroups[1]]: response["wasHelpful"]["2"] || 0,
        [wasHelpfulSubgroups[2]]: response["wasHelpful"]["3"] || 0,
        [wasHelpfulSubgroups[3]]: response["wasHelpful"]["4"] || 0,
        [wasHelpfulSubgroups[4]]: response["wasHelpful"]["5"] || 0,
      }];
      // setup d3 stacked bar chart
      D3Wrapper.setupHorizontalStackedBarChart("#wasHelpful-freq-chart-svg", wasHelpfulSubgroups, wasHelpfulChartDataResponse);
      // setup the chart everytime the window resizes
      window.addEventListener("resize", () => D3Wrapper.setupHorizontalStackedBarChart("#wasHelpful-freq-chart-svg", wasHelpfulSubgroups, wasHelpfulChartDataResponse));

      // create data for d3 stacked bar chart
      const uiIsGoodSubgroups = ["Strongly agree", "Agree", "Neutral", "Disagree", "Strongly disagree"];
      const uiIsGoodChartDataResponse = [{
        label: "uiIsGood",
        [uiIsGoodSubgroups[0]]: response["uiIsGood"]["1"] || 0,
        [uiIsGoodSubgroups[1]]: response["uiIsGood"]["2"] || 0,
        [uiIsGoodSubgroups[2]]: response["uiIsGood"]["3"] || 0,
        [uiIsGoodSubgroups[3]]: response["uiIsGood"]["4"] || 0,
        [uiIsGoodSubgroups[4]]: response["uiIsGood"]["5"] || 0,
      }];
      // setup d3 stacked bar chart
      D3Wrapper.setupHorizontalStackedBarChart("#uiIsGood-freq-chart-svg", uiIsGoodSubgroups, uiIsGoodChartDataResponse);
      // setup the chart everytime the window resizes
      window.addEventListener("resize", () => D3Wrapper.setupHorizontalStackedBarChart("#uiIsGood-freq-chart-svg", uiIsGoodSubgroups, uiIsGoodChartDataResponse));

      // create data for d3 stacked bar chart
      const iWillUseItSubgroups = ["Yes", "No"];
      const iWillUseItChartDataResponse = [{
        label: "iWillUseIt",
        [iWillUseItSubgroups[0]]: response["iWillUseIt"]["yes"] || 0,
        [iWillUseItSubgroups[1]]: response["iWillUseIt"]["no"] || 0,
      }];
      // setup d3 stacked bar chart
      D3Wrapper.setupHorizontalStackedBarChart("#iWillUseIt-freq-chart-svg", iWillUseItSubgroups, iWillUseItChartDataResponse);
      // setup the chart everytime the window resizes
      window.addEventListener("resize", () => D3Wrapper.setupHorizontalStackedBarChart("#iWillUseIt-freq-chart-svg", iWillUseItSubgroups, iWillUseItChartDataResponse));

      // create data for d3 stacked bar chart
      const majorProblemsSubgroups = ["Yes", "No"];
      const majorProblemsChartDataResponse = [{
        label: "majorProblems",
        [majorProblemsSubgroups[0]]: response["majorProblems"]["false"] || 0,
        [majorProblemsSubgroups[1]]: response["majorProblems"]["true"] || 0,
      }];
      // setup d3 stacked bar chart
      D3Wrapper.setupHorizontalStackedBarChart("#majorProblems-freq-chart-svg", majorProblemsSubgroups, majorProblemsChartDataResponse);
      // setup the chart everytime the window resizes
      window.addEventListener("resize", () => D3Wrapper.setupHorizontalStackedBarChart("#majorProblems-freq-chart-svg", majorProblemsSubgroups, majorProblemsChartDataResponse));

      // stop the loading bar
      this.isFeedbackAnalysisChartLoading = false;
    })
    .catch(reason => {
      console.log(reason);
      this.isFeedbackAnalysisChartFailed = true;
      this.isFeedbackAnalysisChartLoading = false;
    });
  }

  logToConsole(obj: any){
    console.log(obj);
  }
}
